import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

export default function MedicalDisclaimer() {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="mt-6 pt-4 border-t border-border">
      {/* Collapsible disclaimer */}
      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        className="flex items-center gap-2 w-full text-left"
        data-testid="medical-disclaimer-toggle"
      >
        <span className="text-base">⚕️</span>
        <span className="flex-1 text-sm font-semibold text-muted-foreground">Medical Disclaimer</span>
        {expanded ? (
          <ChevronUp className="h-4 w-4 text-muted-foreground" />
        ) : (
          <ChevronDown className="h-4 w-4 text-muted-foreground" />
        )}
      </button>

      {expanded && (
        <p className="text-xs text-muted-foreground leading-relaxed mt-2">
          Trata Health is not a medical device and does not diagnose, treat, cure, or prevent any
          medical condition. The information provided is for educational purposes only and should not
          replace professional medical advice. Always consult a qualified healthcare professional for
          medical guidance.
        </p>
      )}

      {/* Terms & Privacy — always visible, outside the collapsible disclaimer */}
      <div className="flex items-center gap-3 mt-3">
        <button
          type="button"
          onClick={() => navigate("/consent")}
          className="text-xs text-primary font-medium hover:underline"
          data-testid="disclaimer-terms"
        >
          Terms of Service
        </button>
        <span className="text-muted-foreground">•</span>
        <button
          type="button"
          onClick={() => navigate("/consent")}
          className="text-xs text-primary font-medium hover:underline"
          data-testid="disclaimer-privacy"
        >
          Privacy Policy
        </button>
      </div>

      <p className="text-[10px] text-muted-foreground/70 text-center mt-3">
        © {new Date().getFullYear()} Trata Health. All rights reserved.
      </p>
    </div>
  );
}
